import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";
import { RhythmPortion } from "../../rhythms/rhythm-types";

const portions: RhythmPortion[] = [
    {
        beatsPerCycle: 16,
        beatsPerMinute: 135,
        startTime: 170.25,
    },
    {
        beatsPerCycle: 16,
        beatsPerMinute: 145,
        startTime: 611,
    },
    {
        beatsPerCycle: 16,
        beatsPerMinute: 0,
        startTime: 690.5,
    },
];

export const mayeeSantSang: CompositionDetails = {
    id: compositionIds.mayeeSantSang,
    rhythmSpec: {
        rhythmPortions: portions,
    },
    media: {
        youtubeVideoId: "7KiRoFH0GwI",
    },
    displayName: "Mayee Sant Sang Jaagi - Guneet Kaur Ji",
    taals: ["punjabi"],
};
